import { render, staticRenderFns } from "./backflush.vue?vue&type=template&id=22cd1c16&"
import script from "./backflush.vue?vue&type=script&lang=js&"
export * from "./backflush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports